import { ITranslationItems } from './language.types';

export const BUTTON_LABELS: ITranslationItems = {
  viewArticles: {
    nl: 'Bekijk alle artikelen',
    en: 'View all articles',
  },
  viewStories: {
    nl: 'Alle verhalen',
    en: 'All stories',
  },
  viewTips: {
    nl: 'Lees meer ondernemersverhalen en tips over',
    en: 'Read more entrepreneurial stories and tips about',
  },
  viewEverything: {
    nl: 'Bekijk alles',
    en: 'View all',
  },
  viewProducts: {
    nl: 'Alle oplossingen',
    en: 'All solutions',
  },
};
